'use client'

import { Stack, useMediaQuery } from '@mui/material';
import { useTranslations } from 'next-intl';
import dynamic from 'next/dynamic';
import { usePathname } from 'next/navigation';
import React from "react";
const MainSection = dynamic(() => import('@/components/pages/profile/main-section'), { ssr: false });
const Title = dynamic(() => import('@/components/pages/program-details/title-container'), { ssr: false });
const HorizontalLinearStepper = dynamic(() => import('@/components/widgets/horizontal-linear-stepper'), { ssr: false });
import '@/components/styles/payments_common.scss';

export default function RootLayout({
    children
}: Readonly<{
    children: React.ReactNode;
}>) {
    const is_mobile = useMediaQuery('(max-width:1024px)');
    const pathname = usePathname();
    const t = useTranslations('payments.new_payment');
    const steps = [t('steps.Information'), t('steps.Payment'), t('steps.Confirm')]

    return (
        <MainSection>

            <Stack
                className={'__layoutPayment__'}
                useFlexGap
                direction={'column'}
                spacing={1}
                width={'100%'}
            >
                <Title
                    title={t('title')}
                    font={is_mobile ? 16 : undefined}
                />

                <h6 className='lg:pl-[69px]'>{t('description')}</h6>

                <div className=' mx-auto mt-8'>
                    <HorizontalLinearStepper
                        steps={steps}
                        activeStep={pathname?.includes('confirm') ? 2 : steps.findIndex(item => pathname?.includes(item.toLowerCase()))}
                    />
                </div>

                {children}

            </Stack>

        </MainSection>
    );
}
